<template>
  <div class="user-register">
    <b-row class="justify-content-center">
      <b-col sm="6">
        <b-card :header="$t('register.title')">
          <i18n
            v-show="!hasSignedUp"
            path="register.introtext"
            tag="b-card-text"
            for="register.title"
          >
            <router-link :to="{name: 'login'}">
              {{ $t('login.title') }}
            </router-link>
          </i18n>

          <b-form
            v-show="!hasSignedUp"
            @submit.prevent="signUp"
          >
            <b-form-group
              label-cols-lg="2"
              :label="$t('register.input.email.label')"
              label-for="input-email"
            >
              <b-form-input
                v-model="username"
                :placeholder="$t('register.input.email.placeholder')"
                type="email"
                id="input-email"
                autocomplete="username"
                :required="true"
              />
            </b-form-group>
            <b-form-group
              label-cols-lg="2"
              :label="$t('register.input.password.label')"
              label-for="input-password"
              :description="$t('register.input.password.description')"
            >
              <b-form-input
                v-model="password"
                :placeholder="$t('register.input.password.placeholder')"
                type="password"
                id="input-password"
                autocomplete="new-password"
                :required="true"
              />
            </b-form-group>
            <b-form-group
              label-cols-lg="2"
              :label="$t('register.input.phone.label')"
              label-for="input-phone"
              :description="$t('register.input.phone.description')"
            >
              <b-form-input
                v-model="phone"
                :placeholder="$t('register.input.phone.placeholder')"
                type="tel"
                id="input-phone"
                :required="true"
                pattern="^\+?[1-9]\d{1,14}$"
                autocomplete="tel"
              />
            </b-form-group>
            <b-button
              type="submit"
              variant="primary"
              block
              :disabled="isLoading"
            >
              <b-spinner
                small
                v-show="isLoading"
              />
              {{ $t('register.submitButtonText') }}
            </b-button>
          </b-form>
          <b-form
            v-show="hasSignedUp"
            @submit.prevent="submitEmailVerificationToken"
          >
            <b-form-group
              label-cols-lg="2"
              :label="$t('register.input.emailVerificationToken.label')"
              label-for="input-email-verification-token"
            >
              <b-form-input
                v-model="emailVerificationToken"
                :placeholder="$t('register.input.emailVerificationToken.placeholder')"
                type="text"
                id="input-email-verification-token"
                :required="true"
              />
              <b-button
                type="submit"
                variant="primary"
                block
                class="mt-3"
                :disabled="isLoading"
              >
                <b-spinner
                  small
                  v-show="isLoading"
                />
                {{ $t('register.submitButtonText') }}
              </b-button>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
export default {
  name: "UserRegister",
  data() {
    return {
      username: "",
      password: "",
      phone: "",
      emailVerificationToken: "",
      isLoading: false
    };
  },
  computed: {
    hasSignedUp: function() {
      return this.$store.state.signedUp;
    }
  },
  created() {
    this.getUsernameFromParam();
  },
  methods: {
    signUp: function() {
      this.isLoading = true;
      this.$store.commit("unsetAllAlerts", true);
      Auth.signUp({
        username: this.username,
        password: this.password,
        attributes: {
          phone_number: this.phone // optional - E.164 number convention
        },
        validationData: [] //optional
      })
        .then(data => {
          this.isLoading = false;
          console.log("signUp Succes:", data);
          this.$store.commit("setAlert", {
            variant: "success",
            message:
              "Account creation successful. We have sent you a token to verify your e-mail address to " +
              data.codeDeliveryDetails.Destination
          });
        })
        .catch(err => {
          this.isLoading = false;
          console.log(err);
          if ({}.hasOwnProperty.call(err, "message")) {
            if (err.code == "UsernameExistsException") {
              // @todo: Add Login Link
              this.$store.commit("setAlert", {
                variant: "danger",
                message: err.message
              });
            } else {
              this.$store.commit("setAlert", {
                variant: "danger",
                message: err.message
              });
            }
          }
        });
    },
    submitEmailVerificationToken: function() {
      this.isLoading = true;
      this.$store.commit("unsetAllAlerts", true);
      // After retrieving the confirmation code from the user
      Auth.confirmSignUp(this.username, this.emailVerificationToken, {
        // Optional. Force user confirmation irrespective of existing alias. By default set to True.
        forceAliasCreation: true
      })
        .then(data => {
          this.isLoading = false;
          console.log("submitEmailVerificationToken Success: ", data);
          this.$store.commit("setAlert", {
            variant: "success",
            message: "E-mail is successfully verified. Login now."
          });
          // Redirect to Login and prefill email address
          this.$router.push({
            name: "login",
            query: { email: this.username }
          });
        })
        .catch(err => console.log("submitEmailVerificationToken Error: ", err));
    },
    getUsernameFromParam: function() {
      if (this.$route.query.email) {
        this.username = this.$route.query.email;
      }
    }
  }
};
</script>